import React from 'react'

import { Link } from 'gatsby'
import $ from 'jquery'

//Helpers
import {
  getLocation,
  getName,
  getFakeAddress,
  getStatus,
  is_Sold,
} from '@helpers/helper.developments'
import { getCover, getQuality, getPriceForMarker } from '@helpers/helper.rendering'
import { getMinAndMaxPrice } from '@helpers/helper.unities'
import { getEnvironment, getPrices, getSurface, makeLink } from '@helpers/helper.properties'
import { Development, Property, RealEstateDataPageComponentData } from 'types'
import Loader from '@components/loader/1'
import { useInView } from 'react-intersection-observer'
// import { changeSelectedAction } from '../../../../redux/propertiesDucks'

interface Props {
  dispatch?: any
  inMap?: boolean
  unities?: Property[]
  development?: Development
  skeleton?: boolean
}

const developmentCard = (props: Props & RealEstateDataPageComponentData) => {
  const { dispatch, development, skeleton, global_data } = props
  const { divisionPath } = global_data
  const { button } = global_data.content.cardsDevelopments.data

  const { ref, inView } = useInView({
    triggerOnce: true, // Cargar solo una vez cuando sea visible
  })

  const inMap = props?.inMap
  const unities = props?.unities || []

  const makeUrlUnities = (unities: Property[]) => {
    let url = ''
    unities.forEach((unity, index) => {
      url += `${unity.id}`
      if (index !== unities.length - 1) {
        url += `-`
      }
    })
    return url
  }

  if (skeleton || !inView) {
    return (
      <div
        ref={ref}
        className="dev a card dev-card skeleton"
      >
        {(skeleton || !inView) && <Loader />}
      </div>
    )
  }

  const toggleModal = (boolean: boolean) => {
    document.body.classList.remove('modal-open')
    // const element = document.getElementById('exampleModal') as HTMLElement
    // element.remove()
    $('#exampleModal').hide()
    $('.modal-backdrop').hide()
    // const modal: any = document.getElementById('exampleModal')
    // modal.classList.remove('show')
    // modal.style.display = 'none'
    document.body.classList.remove('modal-open')
    document.body.style.overflow = 'auto'
  }

  return inMap ? (
    <div
      ref={ref}
      className={'card dev a prop-card ' + (inMap ? 'map-card' : '')}
    >
      <div className={'card-image grid_map_image'}>
        <a target="_blank">
          <img
            src={!skeleton ? getQuality(getCover(development!.photos)) : ''}
            className="notScale"
            alt="Development card image"
          />
          {/* //CONSULTAR */}
        </a>
        <div className="badges">
          <div className={'badge'}>{'EMPRENDIMIENTO'}</div>
        </div>
        {/* <div onClick={() => dispatch(changeSelectedAction(0)) + toggleModal(false)} data-bs-dismiss="modal" className="close-card"><i></i><i></i></div> */}
        <div
          onClick={() => toggleModal(false)}
          data-bs-dismiss="modal"
          className="close-card"
        >
          <i></i>
          <i></i>
        </div>
      </div>
      <div className="card-body">
        <div className="content-extra row d-flex justify-content-between align-items-start">
          <div className="col-12 col-lg-6 mb-3 extra-data">
            <span>{getFakeAddress(development!)}</span>
          </div>
          <div className="col-12 col-lg-6 mb-2 text-lg-end location">
            <span>{getLocation(development!)}</span>
          </div>
        </div>
        <div className="content-extra">
          <h3 className="card-title d-flex flex-column mb-3">
            <a
              className=""
              target={'_blank'}
              href={
                (divisionPath ?? '') +
                '/emprendimiento/' +
                getFakeAddress(development!)
                  ?.replaceAll(' ', '-')
                  ?.replaceAll('/', '-')
                  ?.toLowerCase() +
                '/' +
                development!.id +
                (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
              }
            >
              {getName(development!)}
            </a>
          </h3>
          <div className={'col-12 mb-3 ' + (unities.length < 7 ? 'd-none' : '')}>
            {'Desde USD ' +
              Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(unities)?.min) +
              ' Hasta USD ' +
              Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(unities)?.max)}
          </div>
          <div className="unity mb-3">
            {unities?.length! < 7
              ? unities
                  .sort((a, b) => a.room_amount - b.room_amount)
                  .map((unity, index) => (
                    <span
                      key={index}
                      className="item-unity mb-1 d-flex align-items-center"
                    >
                      {getEnvironment(unity)} ambientes{' '}
                      {getSurface(unity) ? '· ' + getSurface(unity) : ''}{' '}
                      {getPrices(unity).length > 0
                        ? '· ' + getPriceForMarker(getPrices(unity))
                        : ''}{' '}
                      <a
                        className="ms-auto"
                        target={'_blank'}
                        href={makeLink(unity, divisionPath)}
                      >
                        VER{' '}
                      </a>
                    </span>
                  ))
              : ''}
          </div>
          {/* <h3 className={'card-title d-flex flex-column ' + (unities.length < 7 ? 'd-none' : '')}> */}
          <a
            className="btn btn-secondary mt-3 d-block "
            target={'_blank'}
            href={
              (divisionPath ?? '') +
              '/emprendimiento/' +
              getFakeAddress(development!)
                ?.replaceAll(' ', '-')
                ?.replaceAll('/', '-')
                .toLowerCase() +
              '/' +
              development!.id +
              (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
            }
          >
            Ver emprendimiento
          </a>
          {/* </h3> */}
        </div>
      </div>
    </div>
  ) : (
    <div
      ref={ref}
      className={
        'card dev a dev-card ' +
        (inView ? ' animate__animated animate__fadeInUp ' : '') +
        (props.inMap ? 'map-card' : '')
      }
    >
      {is_Sold(development!) && <div className="development-end-tag">100% VENDIDO</div>}
      <div className="card-image">
        <img
          className="card-img"
          alt="Portada imagen emprendimiento"
          src={development && getQuality(getCover(development?.photos))}
        />
      </div>
      <div className="card-img-overlay d-flex align-items-end align-items-lg-start flex-lg-column text-white">
        <div className="content">
          <span className="badge-element">
            Estado <span>----</span> {development && getStatus(development)}
          </span>
          <h2 className="card-title mb-0 mb-lg-3 mt-lg-5">{development && getName(development)}</h2>
          <h4 className="d-inline-block card-title direccion mb-0 mb-lg-1 mt-lg-2">
            {development && getFakeAddress(development)}
          </h4>
          <h5 className="card-location">
            {development && getLocation(development, true)[0]}
            {development && ', ' + getLocation(development, true)[1]}
          </h5>
        </div>
        {props.inMap ? (
          <a
            target={'_blank'}
            href={
              (divisionPath ?? '') +
              '/emprendimiento/' +
              getFakeAddress(development!)
                ?.replaceAll(' ', '-')
                ?.replaceAll('/', '-')
                .toLowerCase() +
              '/' +
              development?.id +
              (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
            }
            className="btn btn-outline mt-auto"
          >
            <span className="d-none d-lg-inline">{button?.value || 'DESCUBRILO'}</span>
            <span className="d-lg-none">+</span>
          </a>
        ) : (
          <a
            target="_blank"
            href={
              (divisionPath ?? '') +
              '/emprendimiento/' +
              getFakeAddress(development!)
                ?.replaceAll(' ', '-')
                ?.replaceAll('/', '-')
                .toLowerCase() +
              '/' +
              development?.id +
              (props.unities ? '?unidades=' + makeUrlUnities(props.unities) : '')
            }
            className="btn btn-outline mt-auto"
          >
            <span className="d-none d-lg-inline">{button?.value || 'DESCUBRILO'}</span>
            <span className="d-lg-none">+</span>
          </a>
        )}
      </div>
    </div>
  )
}

export default developmentCard
